// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__A6Wjq","bar":"Loader_bar__KCP4Q","slide":"Loader_slide__+8Cm2"};